/* Toggle open/closed */
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.tab-text-title').forEach(function (title) {
		title.addEventListener('click', function (e) {
			e.stopImmediatePropagation();
			var parent = title.closest('.tab-text');
			if (parent) {
				parent.classList.toggle('open');
			}
		});
	});

	if (window.innerWidth < 500) {
		document.querySelectorAll('section.faq .tab-text').forEach(function (el) {
			el.classList.remove('open');
		});
	}
});
